import React from 'react';
import './Banner.css';
const imgBanner = 'https://cdn.nudus.app/Images/banner.jpg';

const Banner = ({title}) => {
  return (
    <div className='banner-general-container' style={{backgroundImage: `url(${imgBanner})`}}>
        <div className='banner-general-content'>
            <h3>{title}</h3>
            <span></span>
        </div>
    </div>
  )
}

export default Banner;